import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_316: DocMigration = {
  maxSchemaVersion: "0.0.316",
  description: "Update viewports with defaults",
  apply(json: any) {
    // return early if there are no viewports in the file
    if (!json.viewports || Object.values(json.viewports).length === 0) {
      return json;
    }

    if (json.viewTemplates) {
      // replace any plan specific relaxation labels with the correct label
      for (const viewTemplateId in json.viewTemplates) {
        const layers = json.viewTemplates[viewTemplateId].layers as string[];

        const interiorLabelIndex = layers.indexOf("INTERIOR_LABELS");
        if (interiorLabelIndex !== -1) {
          layers.splice(
            interiorLabelIndex,
            1,
            "WALL_EXTERIOR_DIMENSIONS",
            "WALL_EXTERIOR_DIM_LINEWORK",
            "WALL_EXTERIOR_DIM_TICK",
            "WALL_EXTERIOR_DIM_LABEL",

            "WALL_INTERIOR_DIMENSIONS",
            "WALL_INTERIOR_DIM_LINEWORK",
            "WALL_INTERIOR_DIM_TICK",
            "WALL_INTERIOR_DIM_LABEL",

            "ROOM_LABELS",
            "CASEWORK_LABELS",
          );
        }

        const openingLabelIndex = layers.indexOf("OPENING_TAGS");
        if (openingLabelIndex !== -1) {
          layers.splice(openingLabelIndex, 1, "WINDOW_TAGS", "DOOR_TAGS");
        }
      }
    } else {
      json.viewTemplates = {};
    }

    // add a default view template if there are no view templates
    if (Object.values(json.viewTemplates).length === 0) {
      const id = uid();
      json.viewTemplates[id] = { ...defaultViewTemplate, id };
    }

    const defaultViewTemplateId = Object.values(json.viewTemplates as Object)[0].id;
    const defaultLevelId = Object.values(json.levels as Object)[0].id;

    // update viewports with defaults
    if (json.viewports) {
      for (const viewportId in json.viewports) {
        const viewport = json.viewports[viewportId];
        json.viewports[viewportId] = {
          ...viewportDefaults,
          viewTemplateId: defaultViewTemplateId,
          levelId: defaultLevelId,
          ...viewport,
        };
      }
    }

    return json;
  },
};

const viewportDefaults = {
  name: "Viewport",
  scalingMethod: "FIT",
  positioningMethod: "ALIGNED",
  horizontalAlignment: "CENTER",
  verticalAlignment: "CENTER",
  panX: 0,
  panY: 0,
  scale: 1 / 4 / 12,
};

const defaultViewTemplate = {
  entityType: "VIEW_TEMPLATE",
  sortIndex: 0,
  viewType: "PLAN_VIEW",
  referenceType: "FLOOR",
  name: "Floor Plan",
  cameraKey: "defaultExteriorCamera",
  layers: [
    "SLAB_PATIO",
    "RAILING",
    "RAILING_POST",
    "PROPS",
    "PORCH_COLUMNS",
    "PORCH_BEAMS",
    "PORCH",
    "DECK",
    "PERIMS",
    "WALLS",
    "WALL_ASSEMBLIES",
    "CHASE_ROOMS",
    "STEM_WALL_UNIONED_EDGES",
    "PIER_EDGES_ONLY",
    "STAIR",
    "RAILING_STAIR_ONLY",
    "RAILING_POST_STAIR_ONLY",
    "CASEWORK",
    "CEILING",
    "WAINSCOTING",
    "DOORS",
    "WINDOWS",
    "COLUMN",

    "WALL_EXTERIOR_DIMENSIONS",
    "WALL_EXTERIOR_DIM_LINEWORK",
    "WALL_EXTERIOR_DIM_TICK",
    "WALL_EXTERIOR_DIM_LABEL",

    "WALL_INTERIOR_DIMENSIONS",
    "WALL_INTERIOR_DIM_LINEWORK",
    "WALL_INTERIOR_DIM_TICK",
    "WALL_INTERIOR_DIM_LABEL",

    "ROOM_LABELS",
    "CASEWORK_LABELS",
    "WINDOW_TAGS",
    "DOOR_TAGS",

    "ANNOTATION",
    "ANNOT_LINEWORK_FILL",
    "ANNOT_LINEWORK_LINE",
    "ANNOT_LINEWORK_OFFSETLINE",
    "ANNOT_NOTE",
    "ANNOT_DIM_LABEL",
    "ANNOT_DIM_LINEWORK",
    "ANNOT_DIM_WITNESS",
    "ANNOT_DIM_TICK",
  ],
};

export default migration_0_0_316;
